import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../../../util/utils';
import {updateITControl} from '../../../../../../../actions/ITControl/itcontrolaction';
import {clientSideEventNames} from '../../../../../../../util/uiconstants';
import ToggleSwitch from '../../../../../BaseComponentWrappers/MotifToggleSwitch';

const ISA315ItControlTestingItem = (props) => {
	const dispatch = useDispatch();
	const [hasITControlTesting, sethasITControlTesting] = useState(
		props?.itControl?.hasITControlTesting === true ? true : false
	);

	async function checkChange() {
		try {
			let payload = {
				itControlName: props.itControl.itControlName,
				itApproachTypeId: props.itControl.itApproachTypeId,
				isEffective: null,
				hasITControlTesting: false,
				controlDesignEffectivenessTypeId:
					props.itControl.controlDesignEffectivenessTypeId === 0
						? null
						: props.itControl.controlDesignEffectivenessTypeId
			};
			props.setIsLoading(true);
			sethasITControlTesting(!hasITControlTesting);
			if (!hasITControlTesting) {
				payload = {...payload, hasITControlTesting: true, taskDescription: labels.selectTestingStrategy};
			}

			await dispatch(updateITControl(props.engagementId, props.itControl.id, payload)).then(() =>
				window.dispatchEvent(new CustomEvent(clientSideEventNames.getValidations))
			);
		} finally {
			props.setIsLoading(false);
		}
	}

	useEffect(() => {
		const itControlTestingValue = props?.itControl?.hasITControlTesting === true ? true : false;
		sethasITControlTesting(itControlTestingValue);
	}, [props?.itControl?.hasITControlTesting]);

	return (
		<StyledTestingToggle className="StyledTestingToggle">
			<ToggleSwitch
				checked={hasITControlTesting}
				hideLabels={false}
				onChange={checkChange}
				id={'toggleSwitchId' + props?.itControl?.id}
				disabled={false}
				onLabel={labels.itTestHeader}
				offLabel=""
			/>
		</StyledTestingToggle>
	);
};
export default ISA315ItControlTestingItem;

const StyledTestingToggle = styled.section`
	.motif-toggle-switch-text {
		color: var(--neutrals-900);
	}
`;
